import { GAME_ID, REDUX_ACTIONS, SCREENS } from '../../data/constants';

export const initialState = {
  isAlyxSpeaking: false,
  highestLevelEarned: 0,
  highlightDictionary: false,
  isAudioPlaying: false,
  isDefinitionMode: false,
  isReplayOnboarding: false,
  introOnboardingFinished: false,
  interactionsEnabled: true,
};

const gameDetailsReducer = (state = initialState, { gameId, payload, type }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.SET_INTERACTIONS_ENABLED:
      return {
        ...state,
        interactionsEnabled: payload,
      };
    case REDUX_ACTIONS.SET_INTRO_ONBOARDING_FINISHED:
      return {
        ...state,
        introOnboardingFinished: payload,
      };
    case REDUX_ACTIONS.SET_ALYX_SPEAKING:
      return {
        ...state,
        isAlyxSpeaking: payload,
      };
    case REDUX_ACTIONS.HIGHLIGHT_DICTIONARY:
      return {
        ...state,
        highlightDictionary: payload,
      };

    case REDUX_ACTIONS.SET_HIGHEST_LEVEL_EARNED:
      return {
        ...state,
        highestLevelEarned: payload,
      };

    case REDUX_ACTIONS.SET_IS_AUDIO_PLAYING:
      return {
        ...state,
        isAudioPlaying: payload,
      };

    case REDUX_ACTIONS.TOGGLE_DEFINITION_MODE:
      return {
        ...state,
        isDefinitionMode: !state.isDefinitionMode,
      };

    case REDUX_ACTIONS.REPLAY_ONBOARDING:
      return {
        ...state,
        isReplayOnboarding: payload,
      };

    case REDUX_ACTIONS.CHANGE_SCREEN:
      return (payload === SCREENS.PROGRESS)
        ? {
          ...state,
          isReplayOnboarding: false,
        }
        : state;

    default:
      return state;
  }
};

export default gameDetailsReducer;
